import { observer } from 'mobx-react';
import * as React from 'react';
import { installStripe, StripeProvider } from '../../../utils/Stripe';

export interface AsyncStripeProviderProps {
  render: (stripeReady: boolean) => JSX.Element | null;
}

export interface AsyncStripeProviderState {
  stripe?: stripe.Stripe;
}

const STRIPE_KEY = process.env.REACT_APP_STRIPE_KEY;

@observer
export class AsyncStripeProvider extends React.Component<
  AsyncStripeProviderProps,
  AsyncStripeProviderState
> {
  private mounted: boolean = false;

  constructor(props: AsyncStripeProviderProps) {
    super(props);

    this.state = {};
  }

  async componentDidMount() {
    this.mounted = true;

    const Stripe: stripe.StripeStatic = await installStripe();

    if (this.mounted) {
      this.setState({
        stripe: Stripe(STRIPE_KEY as string)
      });
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  render() {
    const { stripe } = this.state;
    const { render } = this.props;

    return (
      <StripeProvider stripe={stripe || null}>
        {render(!!stripe)}
      </StripeProvider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/Utils/AsyncStripeProvider/index.tsx